import React from 'react';

const ProjectCard = ({ project, onViewDetails }) => {
  return (
    <div className="exclusive-card">
      <div
        className="exclusive-card-hero"
        style={{ backgroundImage: `url(${project.heroImageUrl})` }}
      />
      <div className="exclusive-card-body">
        <div className="exclusive-card-header">
          <h3>{project.name}</h3>
          <p>{project.subtitle}</p>
        </div>
        <div className="exclusive-stats">
          <div className="exclusive-stat">
            <span>Location</span>
            <strong>{project.location || 'N/A'}</strong>
          </div>
          <div className="exclusive-stat">
            <span>Total Plots</span>
            <strong>{project.totalPlots ?? 'N/A'}</strong>
          </div>
          <div className="exclusive-stat">
            <span>Plot Sizes</span>
            <strong>{project.plotSizes || 'N/A'}</strong>
          </div>
          {project.startingPrice ? (
            <div className="exclusive-stat">
              <span>Starting Price</span>
              <strong>{project.startingPrice}</strong>
            </div>
          ) : null}
        </div>
        <div className="exclusive-card-actions">
          <button type="button" className="exclusive-primary" onClick={onViewDetails}>
            View Details
          </button>
          {project.documents?.brochureUrl ? (
            <a
              className="exclusive-secondary"
              href={project.documents.brochureUrl}
              target="_blank"
              rel="noreferrer"
            >
              Download Brochure
            </a>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;
